(function(factory) {
    if (typeof define === "function" && define.amd) {
      // AMD
      define(["jquery", "datatables.net", "datatables-editor"], factory);
    } else if (typeof exports === "object") {
      // Node / CommonJS
      module.exports = function($, dt) {
        if (!$) {
          $ = require("jquery");
        }
        factory($, dt || $.fn.dataTable || require("datatables.net"));
      };
    } else if (jQuery) {
      // Browser standard
      factory(jQuery, jQuery.fn.dataTable);
    }
  })(function($, DataTable) {
    "use strict";
 
    if ( ! DataTable.ext.editorFields ) {
        DataTable.ext.editorFields = {};
    }
     
    var Editor = DataTable.Editor;
    var _fieldTypes = DataTable.ext.editorFields;
     
    _fieldTypes.yesno = {
        create: function ( conf ) {
            var that = this;
     
            conf._enabled = true;

            // Create the elements to use for the input
            const inputId = `${Editor.safeId( conf.id )}-input`;

            const checked = conf.def ? 'checked' : '';

            conf._input = $(
                `<div id=${Editor.safeId( conf.id )} class="switch-button switch-button-yesno">`+
                    `<input type="checkbox" ${checked} name="${inputId}" id="${inputId}" />`+
                        `<span><label for="${inputId}"></label></span>`+
                '</div>');
     
            return conf._input;
        },
     
        get: function ( conf ) {
            return $('input', conf._input).prop('checked');
        },
     
        set: function ( conf, val ) {
            $('input', conf._input).prop('checked', val);
        },
     
        enable: function ( conf ) {
            conf._enabled = true;
            $(conf._input).removeClass( 'disabled' );
        },
     
        disable: function ( conf ) {
            conf._enabled = false;
            $(conf._input).addClass( 'disabled' );
        }
    };
});


// WEBPACK FOOTER //
// ./src/assets/plugins/datatables/editor/fields/yesno.js